module.exports = __webpack_public_path__ + "static/media/logo.45801c90.png";